import clsx from 'clsx';
import { Link, type GatsbyLinkProps } from 'gatsby';
import type { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';

type Props = GatsbyLinkProps<unknown> & {
  className?: string;
  children: ReactNode;
};

export const Anchor: FC<Props> = ({
  className,
  to,
  children,
  ['aria-label']: ariaLabel,
  activeClassName = 'current',
  partiallyActive = false,
}) => {
  const isInternal = to?.startsWith('/');
  if (isInternal) {
    return (
      <StyledLink
        className={clsx(className)}
        to={to?.endsWith('/') ? to : `${to}/`}
        aria-label={ariaLabel || ''}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
      >
        {children}
      </StyledLink>
    );
  } else {
    return (
      <StyledA
        className={clsx(className)}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel || ''}
      >
        {children}
      </StyledA>
    );
  }
};

const BaseStyle = css`
  &:hover,
  &:focus-visible {
    text-decoration: line-through;
  }
`;

const StyledLink = styled(Link)`
  ${BaseStyle}
`;

const StyledA = styled.a`
  ${BaseStyle}
`;

export default Anchor;
